import { useApp } from "@/context/AppContext";
import { ExperienceFeed } from "@/components/experiences/ExperienceFeed";

export default function Community() {
  const { t } = useApp();
  return <div className="space-y-6 pb-6">
    <header className="pb-2 pt-4"><p data-testid="community-eyebrow" className="text-xs font-bold tracking-wider text-terracotta">{t("experience_eyebrow")}</p><h1 data-testid="community-title" className="mt-3 font-heading text-4xl font-extrabold leading-tight text-ink">{t("experiences")}</h1></header>
    <ExperienceFeed />
  </div>;
}